import { autorun } from "mobx";

export const watchComputed = (
  instance: { [key: string]: any },
  computedName: string,
  delay: number = 0,
  debug: boolean = false
) => {
  return autorun(
    () => {
      if (debug) console.warn("Debug watchComputed:", computedName);
      if (!instance) throw Error(`Send 'this' to be watched`);
      if (!computedName) throw Error(`Send 'computedName' to be watched`);
      return instance[computedName];
    },
    { delay: delay }
  );
};
